 import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { fetchInquiries, deleteInquiry } from "store/contactSlice";


export default function InquiryTable({ color }) {
const dispatch = useDispatch();
const { items, loading, error } = useSelector((s) => s.contacts);


useEffect(() => { dispatch(fetchInquiries()); }, [dispatch]);


const handleDelete = (id) => {
if (window.confirm("Delete this inquiry?")) dispatch(deleteInquiry(id));
};


return (
    <div className={"relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " + (color === "light" ? "bg-white" : "bg-lightBlue-900 text-white")}>
<div className="rounded-t mb-0 px-4 py-3 border-0"><h3 className="font-semibold text-lg">Contact Inquiries</h3></div>
<div className="block w-full overflow-x-auto">
<table className="items-center w-full bg-transparent border-collapse">
<thead>
<tr>{["Name","Email","Company","Service Needed","Budget","Message","Actions"].map((h,i)=>(
<th key={i} className={`px-6 py-3 text-xs uppercase font-semibold text-left ${color==="light"?"bg-blueGray-50 text-blueGray-500":"bg-lightBlue-800 text-lightBlue-300"}`}>{h}</th>
))}</tr>
</thead>
<tbody>
{loading ? (
  <tr><td colSpan="7" className="text-center p-4">Loading...</td></tr>
) : error ? (
  <tr><td colSpan="7" className="text-center p-4 text-red-500">{error}</td></tr>
) : items.length === 0 ? (
  <tr><td colSpan="7" className="text-center p-4">No inquiries found.</td></tr>
) : (
  items.map((i) => (
    <tr key={i.id}>
      <td className="px-6 py-4 text-sm">{i.full_name}</td>
      <td className="px-6 py-4 text-sm">{i.email_address}</td>
      <td className="px-6 py-4 text-sm">{i.company_name}</td>
      <td className="px-6 py-4 text-sm">{i.service_needed}</td>
      <td className="px-6 py-4 text-sm">{i.budget_range}</td>
      <td className="px-6 py-4 text-sm">{i.project_details}</td>
      <td className="px-6 py-4 text-sm">
        <button
          onClick={() => handleDelete(i.id)}
          className="bg-red-500 text-white px-3 py-1 rounded text-xs"
        >
          Delete
        </button>
      </td>
    </tr>
  ))
)}
</tbody>

</table>
</div>
</div>
);
}


InquiryTable.defaultProps = { color: "light" };
InquiryTable.propTypes = { color: PropTypes.oneOf(["light","dark"]) };